import React from 'react';
import { isEmpty } from '../../../util/isEmpty';

/**
 * Displays the current cart count in sync with Shopify
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const CartCount = ({ count, cart }) => <span>{count}</span>;

export default CartCount;
